import { themeColors } from '@/theme/colors';

export const LeftFoot = () => (
  <path
    d='M100.571 455.929C104.321 455.554 109.384 451.431 111.447 454.242C113.51 457.053 112.947 467.734 112.385 472.419C111.822 477.104 112.01 480.102 108.822 481.789C105.634 483.475 99.0706 483.101 93.0699 483.101C87.0693 483.101 76.0056 482.913 72.2552 481.414C68.5048 479.915 69.8174 476.542 70.9425 474.293C72.0676 472.044 76.3805 470.358 79.1933 468.297C82.2031 466.091 85.0834 463.713 87.8194 461.176C89.5071 459.302 87.0693 457.615 89.132 456.866C91.1948 456.116 96.8204 456.491 100.571 455.929Z'
    stroke={themeColors.sensorPlacementOutline}
    strokeWidth='1.87457'
  />
);
